import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Input } from "@faire/web--source/slate-labs/Input";
import { Button } from "@faire/web--source/slate/Button";
import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { FormField, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Spacer } from "@faire/web--source/slate/spacing";
import { DefaultTheme } from "@faire/web--source/slate/Theme";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterEditAccountEmailClick } from "@faire/web-api--source/events/helpCenter/click/editAccountEmail";
import { Form, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useEditSettingsLink } from "../../hooks/useEditSettingsLink";
import { AttachmentFormField } from "./AttachmentFormField";
export var TicketForm = function TicketForm(_ref) {
  var attachment = _ref.attachment,
    setAttachment = _ref.setAttachment,
    isLoading = _ref.isLoading,
    errorMessage = _ref.errorMessage,
    setErrorMessage = _ref.setErrorMessage;
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched,
    getFieldProps = _useFormikContext.getFieldProps,
    isValid = _useFormikContext.isValid;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitClicked = _useState2[0],
    setIsSubmitClicked = _useState2[1];
  var editSettingsLink = useEditSettingsLink();
  useEffect(function () {
    if (!isValid && isSubmitClicked) {
      setIsSubmitClicked(false);
      setErrorMessage(strictLocalize({
        id: "OKJwoz",
        defaultMessage: [{
          "type": 0,
          "value": "Fyll i alla obligatoriska fält för att skicka denna förfrågan"
        }]
      }));
    }
    if (isValid) {
      setErrorMessage("");
    }
  }, [isValid, isSubmitClicked, strictLocalize, setErrorMessage]);
  var handleEditSettingsClick = function handleEditSettingsClick() {
    var _getRetailerToken, _getBrandToken;
    trackHelpCenterEditAccountEmailClick((_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "");
  };
  return /*#__PURE__*/React.createElement(Form, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    "$name": "name"
  }, /*#__PURE__*/React.createElement(Input, _objectSpread({
    label: strictLocalize({
      id: "APaGyM",
      defaultMessage: [{
        "type": 0,
        "value": "Ditt namn*"
      }]
    }),
    error: touched.name ? errors.name : false
  }, getFieldProps("name")))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(FormField, {
    "$name": "email"
  }, /*#__PURE__*/React.createElement(Input, _objectSpread(_objectSpread({
    type: "email",
    label: strictLocalize({
      id: "nm04Fh",
      defaultMessage: [{
        "type": 0,
        "value": "Kontots e-postadress"
      }]
    }),
    error: touched.email && errors.email
  }, getFieldProps("email")), {}, {
    disabled: true,
    sideCta: /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: editSettingsLink,
      onClick: handleEditSettingsClick,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "IB23ey",
      defaultMessage: [{
        "type": 0,
        "value": "Redigera inställningar"
      }]
    }))
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(FormField, {
    "$name": "subject"
  }, /*#__PURE__*/React.createElement(Input, _objectSpread({
    "data-test-id": "subject-input",
    label: strictLocalize({
      id: "A04DHe",
      defaultMessage: [{
        "type": 0,
        "value": "Ämne*"
      }]
    }),
    error: touched.subject && errors.subject
  }, getFieldProps("subject")))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(FormField, {
    "$name": "orderNumber"
  }, /*#__PURE__*/React.createElement(Input, _objectSpread({
    "data-test-id": "order-number-input",
    label: strictLocalize({
      id: "1iqW9Y",
      defaultMessage: [{
        "type": 0,
        "value": "Beställningsnummer (valfritt)"
      }]
    }),
    error: touched.orderNumber && errors.orderNumber
  }, getFieldProps("orderNumber")))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(FormField, {
    "$name": "description"
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, DefaultTheme), {}, {
      input: _objectSpread(_objectSpread({}, DefaultTheme.input), {}, {
        helper: _objectSpread(_objectSpread({}, DefaultTheme.input.helper), {}, {
          color: Core.text.subdued
        })
      })
    })
  }, /*#__PURE__*/React.createElement(TextArea, _objectSpread({
    "data-test-id": "description-input",
    style: {
      height: "120px"
    },
    maxLength: 4000,
    helper: strictLocalize({
      id: "01Lruf",
      defaultMessage: [{
        "type": 0,
        "value": "Beskriv problemet mer i detalj"
      }]
    }),
    label: strictLocalize({
      id: "1HDbhP",
      defaultMessage: [{
        "type": 0,
        "value": "Meddelande*"
      }]
    }),
    error: touched.description && errors.description
  }, getFieldProps("description"))))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(FormField, {
    "$name": "websiteUrl"
  }, /*#__PURE__*/React.createElement(Input, _objectSpread({
    label: strictLocalize({
      id: "TzsVzR",
      defaultMessage: [{
        "type": 0,
        "value": "Faire-webbadress (valfritt)"
      }]
    }),
    error: touched.websiteUrl && errors.websiteUrl
  }, getFieldProps("websiteUrl"))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued,
    variant: "labelSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eyFiWc",
    defaultMessage: [{
      "type": 0,
      "value": "Ange ärende-URL om tillämpligt"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(AttachmentFormField, {
    attachment: attachment,
    setAttachment: setAttachment
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    "data-test-id": "submit-btn",
    type: "submit",
    disabled: isLoading,
    onClick: function onClick() {
      return setIsSubmitClicked(true);
    }
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iaPUy/",
    defaultMessage: [{
      "type": 0,
      "value": "Skicka in"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), isLoading ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: "medium"
  }) : null), errorMessage && !isLoading ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, errorMessage))) : null);
};